// =============================================================================
// careConflictsCore.js - pure helpers for the Care Schedule clash check
// (no network; unit-tested). The RPC wrapper is in careConflicts.js.
// =============================================================================
export const CARE_OVERRIDE_REASONS = [
  "Patient asked for this time",
  "Same trip, back to back is fine",
  "Joint visit",
  "Covering for a colleague",
  "Other",
];

const KIND = { chw: "a CHW visit", cm: "a CM touchpoint", conference: "a care conference", appointment: "a clinic visit" };

export function conflictRange(c) {
  const s = new Date(c.at);
  const e = new Date(s.getTime() + (Number(c.minutes) || 30) * 60000);
  const f = (d) => d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return f(s) + " - " + f(e);
}

export function conflictLine(c, { assigneeIsMe = false } = {}) {
  const what = KIND[c.kind] || "something";
  if (c.who === "staff") {
    const who = assigneeIsMe ? "You already have " : "They already have ";
    return who + what + " " + conflictRange(c) + (c.same_patient ? " with this patient" : "") + ".";
  }
  if (c.kind === "appointment") return "The patient has " + what + (c.label ? " (" + c.label + ")" : "") + " " + conflictRange(c) + ".";
  return "The patient has " + what + " with someone else on the care team " + conflictRange(c) + ".";
}

// Changes worth re-checking: time, length, who, or which patient.
export function scheduleChanged(existing, { at, minutes, userId, patientId }) {
  if (!existing) return true;
  return new Date(at).getTime() !== new Date(existing.scheduled_at).getTime()
    || Number(minutes || 0) !== Number(existing.scheduled_duration_minutes || 0)
    || (userId || null) !== (existing.scheduled_for_user_id || null)
    || (patientId || null) !== (existing.patient_id || null);
}
